import React, { memo } from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
import convertToHtml from '../../../../Components/FormBuilder/Builder/FormInputs/convertDraftjsToHtml';
import  '../../custom.css';
import { getUserInfo } from '../../../../Utils/UserFunctions';


const SubFormHead = ({ section, validationForms, keyIndex, tHeadClassName,...props }) => {
    let sectionData = section.data;
    const userInfo = getUserInfo();
    if (userInfo?.data?.role_name === 'Community Partners') {
    sectionData = section.data.filter(
        (item) => item.api_custom_field_name !== "cf_quoted_cost"
    );
    }

    return (
        <thead className={tHeadClassName}>
            <tr key={keyIndex}>
                {isSet(props.isWrite,true)===true && 
                    <th style={{ width: '30px' }} className='fixed-first-col'></th>
                }
                {sectionData.map((item, index) => {
                    const isHidden = isSet(item.access_mode, 'EDITABLE') === 'HIDDEN';
                    const isAddForm = isSet(item.is_add_form, false) === true;

                    if (isHidden || !isAddForm) return null;

                    return (
                        <th key={'head_' + index}>
                            <span>{convertToHtml(item.label)}</span>
                            {validationForms[item.id] ? (
                                <div>
                                    <span className="text-danger m-1">{validationForms[item.id]}</span>
                                </div>
                            ) : null}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};

const isDiffProps = (prevProps, nextProps) => {
    const areSectionDataEqual = JSON.stringify(prevProps.section.data) === JSON.stringify(nextProps.section.data);
    const areValidationFormsEqual = JSON.stringify(prevProps.validationForms) === JSON.stringify(nextProps.validationForms);
    return areSectionDataEqual && areValidationFormsEqual;
};

// Default props
SubFormHead.defaultProps = {
    tHeadClassName: '',
};

export default memo(SubFormHead);